import React from "react"
import { createNativeStackNavigator } from "@react-navigation/native-stack"
import { ReportHome } from "@Screens/FollowUp/Reports/ReportHome"
import { ReportDetails } from "@Screens/FollowUp/Reports/ReportDetails"
import { EvaluationHome } from "@Screens/FollowUp/Evaluation/EvaluationHome"
import { EvaluationDetail } from "@Screens/FollowUp/Evaluation/EvaluationDetail"
import KnowledgeStack from "@Navigation/KnowledgeStack/KnowledgeStack"
import Savoirs from "@Screens/Knowledge/Savoirs/Savoirs"
import SavoirFaire from "@Screens/Knowledge/SavoirFaire/SavoirFaire"
import SavoirEtre from "@Screens/Knowledge/SavoirEtre/SavoirEtre"

const MainStackNavigator = createNativeStackNavigator()
export const EvaluationStack = () => {
    return (
        <MainStackNavigator.Navigator
            screenOptions={{
                headerShown: false
            }}
            initialRouteName="EvaluationHome"
        >
            <MainStackNavigator.Screen name={"EvaluationHome"} component={EvaluationHome} />
            <MainStackNavigator.Screen name={"EvaluationDetails"} component={EvaluationDetail} />
            <MainStackNavigator.Screen name="Savoirs" component={Savoirs} />
            <MainStackNavigator.Screen name="SavoirFaire" component={SavoirFaire} />
            <MainStackNavigator.Screen name="SavoirEtre" component={SavoirEtre} />
            <MainStackNavigator.Screen name={"KnowledgeStack"} component={KnowledgeStack} />
        </MainStackNavigator.Navigator>
    )
}
